const services = [
    {
        num: "01",
        title: "Brand Identity",
        desc: "Positioning that makes you the go-to name in your niche.",
    },
    {
        num: "02",
        title: "Content Creation",
        desc: "Cinematic reels, editorial portraits, project walk-throughs.",
    },
    {
        num: "03",
        title: "Social Media",
        desc: "Daily posting, engagement and community across every platform.",
    },
    {
        num: "04",
        title: "Lead Generation",
        desc: "Meta & Google Ads. High-intent leads at sub-AED 20 CPL.",
    },
];

export default function Services() {
    return (
        <section id="services" className="relative py-24 sm:py-32 border-t border-white/10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-16">
                    <div className="md:col-span-4">
                        <div className="eyebrow mb-4 flex items-center gap-3">
                            <span className="inline-block w-10 h-[2px] bg-brand" /> What we do
                        </div>
                    </div>
                    <h2 className="md:col-span-8 font-display font-medium tracking-[-0.04em] text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]">
                        Four disciplines.<br />
                        <span className="text-white/40">One outcome:</span> <span className="text-brand">trust that converts.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 border-t border-white/10">
                    {services.map((s, i) => (
                        <div
                            key={s.num}
                            className={`group relative p-8 sm:p-12 border-b border-white/10 ${
                                i % 2 === 0 ? "md:border-r border-white/10" : ""
                            } hover:bg-white/[0.02] transition-colors`}
                        >
                            <div className="flex items-start gap-6">
                                <div className="font-mono text-brand text-sm shrink-0 pt-2">{s.num}</div>
                                <div>
                                    <h3 className="font-display font-medium text-3xl sm:text-4xl text-white group-hover:text-brand transition-colors leading-tight tracking-[-0.03em]">
                                        {s.title}
                                    </h3>
                                    <p className="mt-4 text-white/60 leading-relaxed text-base max-w-md">{s.desc}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
